import axios from 'axios'
import qs from 'qs';
import router from '../router'

// 使用自定义配置新建一个 axios 实例
const service= axios.create({
   // 基础的请求地址
    baseURL: 'https://www.ls-shipyard.cn/Api',
   // 设置超时时间 10s
    timeout: 10000
});
// 请求拦截器，例如请求的时候在头部加上请求的token
service.interceptors.request.use(config => {
  const Language = localStorage.getItem('language') || 'CH'
  const lang = Language == 'EN'?'en':'cn'
  config.headers.Lang = lang

  if (config.method === 'post') {
    // 修改 Content-Type
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

    // 将对象参数转换为序列化的 URL 形式（key=val&key=val）
    config.data = qs.stringify({
      ...config.data // 后台数据接收这块需要以表单形式提交数据，而axios中post默认的提交是json数据,所以这里选用qs模块来处理数据，也有其他处理方式，但个人觉得这个方式最简单好用
    })
  }
  

  return config;  //  有且必须有一个config对象被返回
}, error => {
   //对请求错误做些什么
    console.log("error::::::::");
    console.log(error);
    return Promise.reject();
});

// 响应拦截器,例如判断服务器返回的状态，400，500啥的，其实超时可以写到这里面来，我分开写了一个比较直观
service.interceptors.response.use(
    response => {
        //console.log(response);
        if (response.status === 200) {
            const res = response.data
            if(res.code == 200){
              return Promise.resolve(response.data);
            }else if(res.error == 400){
              // token 失效 清除token
              localStorage.clear()
              // 跳转登录
              setTimeout(() => {
                 router.push({ path: '/'});
              }, 1000);
            }else{
              alert(res.msg);
              return Promise.reject('error');
            }

        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况,这些自定义（需要与后台商量返回）
    error => {
      //console.log(error);  
      if (400 <= error.response.status < 500) {
            // 跳转登录
            setTimeout(() => {
               router.push({ path: '/'});
            }, 1000);
        } else {
            if (error.response.status >= 500) {
                alert("服务器开小差了，请稍后再试！");
            } else {
                alert("服务器开小差了，请稍后再试！");
                return Promise.reject(error)
            }
        }
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/request/http.js